import React, { useEffect } from "react";
import { Grid, Card, Typography, Box, Button, FormControl, Stack, MenuItem, InputLabel, Select } from "@mui/material";
import { localizedName } from "../../helper/LangHelper";
import { timeToDateStr } from "../../helper/StringHelper";
import { useNavigate } from "react-router-dom";
// import { MemberApi } from "../api/MemberApi";
// import { useSelector, useDispatch } from "react-redux";
// import { memberID, updateAuthState } from "../reducers/userSlice";
import { dateValueToTimeStr } from "../../helper/StringHelper";
import CommonDataSelection from "../common/CommonDataSelection/CommonDataSelection";
import CommonDatePicker from "../common/CommonDatePicker/CommonDatePicker";
import CommonDashboardCard from "../common/CommonDashboardCard/CommonDashboardCard";
import MainCard from "../common/MainCard/MainCard";

import Accordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionSummary, {
    AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MemberScoreRecordTable from "./MemberScoreRecordTable";

function getDefaultEventID(eventList) {
    if (eventList.length > 0) {
        return eventList[0].id;
    }

    return 0;
}

function getEventFromList(eventList, eventID) {
    for (let event of eventList) {
        if (event.id === eventID) {
            return event;
        }
    }

    return null;
}

export default function SkillStatCard({ stat }) {

    const formatValue = (value) => {
        const floatVal = (value === null) ? 0
            : parseFloat(value).toFixed(stat.info.decimal_place);

        return `${floatVal} ${stat.info.unit}`;
    }

    return (
        <Stack spacing={0}>
            <Box>
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                    {stat.info.name}
                </Typography>
            </Box>
            <Grid container alignItems="center">
                <Grid item xs={3} sx={{ p: 2 }}>
                    <CommonDashboardCard title="參與人次" value={stat.total} />
                </Grid>

                <Grid item xs={3} sx={{ p: 2 }}>
                    <CommonDashboardCard title="參與人數" value={stat.member_count} />
                </Grid>

                <Grid item xs={3} sx={{ p: 2 }}>
                    <CommonDashboardCard title="最佳成績" value={formatValue(stat.best)} />
                </Grid>

                <Grid item xs={3} sx={{ p: 2 }}>
                    <CommonDashboardCard title="平均成績" value={formatValue(stat.avg)} />
                </Grid>

                <Grid item xs={12} sx={{ px: 2 }}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ArrowForwardIosSharpIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>前名次參與者</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <MemberScoreRecordTable recordList={stat.top_records} />
                            {/* <pre>
                            top_members: {JSON.stringify(stat.top_records, null, 2)}
                            </pre> */}
                        </AccordionDetails>
                    </Accordion>
                    {/* <pre>
                        {JSON.stringify(stat, null, 2)}
                    </pre> */}
                </Grid>


            </Grid>



            <pre>
                {/* DEBUG: eventID={eventID} timeslot: {timeslotID} skill: {skillID} selectedDate: {dateValueToTimeStr(selectedDate)} 
            <br/>
            {JSON.stringify(eventList, null, 2)} */}
            </pre>
        </Stack>
    );
}